import { FunctionComponent } from 'react';
import { Form as BootstrapForm, FormProps } from 'react-bootstrap';
import classNames from 'classnames';

import classes from './form.module.scss';

type Props = FormProps & {
  centered?: boolean;
  className?: string;
  [key: string]: any;
};

export const Form: FunctionComponent<Props> = ({
  centered,
  className,
  ...props
}) => (
  <BootstrapForm
    className={classNames(
      classes.form,
      centered && classes.centered,
      className
    )}
    {...props}
  />
);
